export * from './formatOptimizedSpeeds';
